<template>
  <v-container
    fluid
    class="pa-4 pa-sm-6"
  >
    <v-row justify="center">
      <v-col cols="12">
        <base-material-card
          icon="mdi-connection"
          title="Integrações"
          color="primary"
          :loading="loading"
          class="px-4 px-md-5 py-3"
        >
          <v-tabs v-model="tab"
                  background-color="transparent"
                  color="primary"
                  class="mb-4"
          >
            <v-tab>Integrações Cadastradas</v-tab>
            <v-tab>Credenciais de API</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <!-- TAB 1: INTEGRAÇÕES -->
            <v-tab-item>
              <!-- Search & Action Header -->
              <v-row
                align="center"
                justify="space-between"
                class="mb-4"
              >
                <v-col
                  cols="12"
                  sm="7"
                  md="5"
                  lg="4"
                >
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar..."
                    single-line
                    hide-details
                    outlined
                    dense
                    clearable
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="5"
                  md="4"
                  class="d-flex justify-start justify-sm-end mt-2 mt-sm-0"
                >
                  <v-btn
                    color="primary"
                    class="rounded-pill px-4"
                    @click="openDialog()"
                  >
                    <v-icon left>
                      mdi-plus-circle
                    </v-icon>
                    Nova Integração
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Data Table -->
              <v-data-table
                :headers="headers"
                :items="integrations"
                :search="search"
                :loading="loading"
                loading-text="Carregando integrações..."
                class="elevation-1"
              >
                <template #[`item.contactName`]="{ item }">
                  <span v-if="item.contactName">
                    <v-icon
                      small
                      color="grey"
                      class="mr-1"
                    >mdi-account-outline</v-icon>
                    {{ item.contactName }}
                  </span>
                  <span
                    v-else
                    class="grey--text text--lighten-1"
                  >-</span>
                </template>

                <template #[`item.contactEmail`]="{ item }">
                  <span v-if="item.contactEmail">
                    <v-icon
                      small
                      color="grey"
                      class="mr-1"
                    >mdi-email-outline</v-icon>
                    {{ item.contactEmail }}
                  </span>
                  <span
                    v-else
                    class="grey--text text--lighten-1"
                  >-</span>
                </template>

                <template #[`item.contactPhone`]="{ item }">
                  <span v-if="item.contactPhone">
                    <v-icon
                      small
                      color="grey"
                      class="mr-1"
                    >mdi-phone-outline</v-icon>
                    {{ item.contactPhone }}
                  </span>
                  <span
                    v-else
                    class="grey--text text--lighten-1"
                  >-</span>
                </template>


                <template #[`item.createdAt`]="{ item }">
                  {{ formatDate(item.createdAt) }}
                </template>

                <template #[`item.actions`]="{ item }">
                  <v-btn
                    icon
                    x-small
                    color="blue"
                    class="mr-1"
                    @click="openDialog(item)"
                  >
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    x-small
                    color="error"
                    @click="deleteItem(item)"
                  >
                    <v-icon small>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-tab-item>

            <!-- TAB 2: CREDENCIAIS -->
            <v-tab-item>
              <legacy-credentials-list />
            </v-tab-item>
          </v-tabs-items>
        </base-material-card>
      </v-col>
    </v-row>

    <!-- Dialog Form -->
    <v-dialog
      v-model="dialog"
      max-width="700px"
      persistent
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          flat
          dense
        >
          <v-toolbar-title class="text-h6">
            {{ formTitle }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-form
            ref="form"
            v-model="valid"
          >
            <v-container class="pa-0">
              <v-row dense>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="editedItem.shortName"
                    label="Nome Curto (shortName)"
                    :rules="[v => !!v || 'Campo obrigatório']"
                    required
                    dense
                    outlined
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="editedItem.name"
                    label="Nome da Integração"
                    :rules="[v => !!v || 'Campo obrigatório']"
                    required
                    dense
                    outlined
                  />
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="editedItem.description"
                    label="Descrição"
                    rows="2"
                    dense
                    outlined
                  />
                </v-col>


                <v-col cols="12">
                  <v-divider class="my-2" />
                  <div class="subtitle-2 font-weight-bold mb-2 primary--text d-flex align-center">
                    <v-icon
                      small
                      color="primary"
                      class="mr-2"
                    >
                      mdi-account-box-outline
                    </v-icon>
                    Contato do Representante
                  </div>
                </v-col>

                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                >
                  <v-text-field
                    v-model="editedItem.contactName"
                    label="Nome do Contato"
                    dense
                    outlined
                    prepend-inner-icon="mdi-account"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    v-model="editedItem.contactEmail"
                    label="E-mail de Notificação"
                    dense
                    outlined
                    prepend-inner-icon="mdi-email"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    v-model="editedItem.contactPhone"
                    label="Telefone / WhatsApp"
                    dense
                    outlined
                    prepend-inner-icon="mdi-phone"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-4 pb-4">
          <v-spacer />
          <v-btn
            color="error"
            text
            class="rounded-pill px-4"
            @click="closeDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            class="rounded-pill px-4"
            :disabled="!valid"
            :loading="saving"
            @click="save"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { $k } from '@/lib/kraken'
  import LegacyCredentialsList from './components/integrations/LegacyCredentialsList.vue'

  export default {
    name: 'Integrations',
    components: { LegacyCredentialsList },

    data: () => ({
      tab: 0,
      loading: false,
      saving: false,
      search: '',
      dialog: false,
      valid: false,
      integrations: [],
      headers: [
        { text: 'ID', value: '_id' },
        { text: 'Nome Curto', value: 'shortName' },
        { text: 'Nome', value: 'name' },
        { text: 'Descrição', value: 'description' },
        { text: 'Contato', value: 'contactName' },
        { text: 'E-mail Contato', value: 'contactEmail' },
        { text: 'Telefone Contato', value: 'contactPhone' },
        { text: 'Criado em', value: 'createdAt' },
        { text: 'Ações', value: 'actions', sortable: false, align: 'right' },
      ],
      editedIndex: -1,
      editedItem: {
        shortName: '',
        name: '',
        description: '',
        contactName: '',
        contactEmail: '',
        contactPhone: '',
      },
      defaultItem: {
        shortName: '',
        name: '',
        description: '',
        contactName: '',
        contactEmail: '',
        contactPhone: '',
      },

    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nova Integração' : 'Editar Integração'
      },
    },

    created () {
      this.fetchData()
    },

    methods: {
      formatDate (dateString) {
        if (!dateString) return '-'
        const date = new Date(dateString)
        return date.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
      },
      async fetchData () {
        this.loading = true
        try {
          const res = await $k.manage.integrations.get()
          this.integrations = res.results || res.result || res || []
        } catch (error) {
          console.error(error)
          if (this.$alert) this.$alert('error', 'Erro ao carregar integrações')
        } finally {
          this.loading = false
        }
      },

      openDialog (item) {
        if (item) {
          this.editedIndex = this.integrations.indexOf(item)
          this.editedItem = Object.assign({}, item)
        } else {
          this.editedIndex = -1
          this.editedItem = Object.assign({}, this.defaultItem)
        }
        this.dialog = true
        if (this.$refs.form) this.$refs.form.resetValidation()
      },

      closeDialog () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        if (!this.$refs.form.validate()) return

        this.saving = true
        try {
          if (this.editedIndex > -1) {
            // Update
            await $k.manage.integrations._id.put({
              id: this.editedItem._id,
              ...this.editedItem,
            })
            if (this.$alert) this.$alert('success', 'Integração atualizada com sucesso')
          } else {
            // Create
            await $k.manage.integrations.post(this.editedItem)
            if (this.$alert) this.$alert('success', 'Integração criada com sucesso')
          }
          this.closeDialog()
          this.fetchData()
        } catch (error) {
          console.error(error)
          if (this.$alert) this.$alert('error', 'Erro ao salvar integração')
        } finally {
          this.saving = false
        }
      },

      async deleteItem (item) {
        if (confirm('Tem certeza que deseja excluir esta integração?')) {
          try {
            await $k.manage.integrations._id.delete({ id: item._id })
            if (this.$alert) this.$alert('success', 'Integração excluída com sucesso')
            this.fetchData()
          } catch (error) {
            console.error(error)
            if (this.$alert) this.$alert('error', 'Erro ao excluir integração')
          }
        }
      },
    },
  }
</script>

<style scoped>
.v-btn.rounded-pill {
  border-radius: 50px !important;
  text-transform: none !important;
  font-weight: 600;
}
</style>
